const RAW_BASE = process.env.REACT_APP_API_BASE_URL || "/api";
const BASE = RAW_BASE.replace(/\/+$/, "");

function getToken() { return localStorage.getItem("chordsn_token"); }
export function setToken(t) { localStorage.setItem("chordsn_token", t); }
export function clearToken() { localStorage.removeItem("chordsn_token"); }

async function req(method, path, body) {
  const headers = { "Content-Type": "application/json" };
  const token = getToken();
  if (token) headers["Authorization"] = "Bearer " + token;
  const res = await fetch(BASE + path, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Fehler");
  return data;
}

// Auth
export const login       = (u, p) => req("POST", "/auth/login",    { username: u, password: p });
export const register    = (body)  => req("POST", "/auth/register", body);
export const getMe       = ()      => req("GET",  "/auth/me");

// User self
export const updateProfile  = (body) => req("PATCH", "/user/profile",  body);
export const changePassword  = (body) => req("PATCH", "/user/password", body);

// Progress
export const getProgress    = ()           => req("GET",    "/progress");
export const saveDay        = (date, body) => req("PUT",    "/progress/" + date, body);
export const deleteDay      = (date)       => req("DELETE", "/progress/" + date);

// Pieces
export const getPieces        = ()           => req("GET",    "/pieces");
export const createPiece      = (body)       => req("POST",   "/pieces",           body);
export const updatePiece      = (id, body)   => req("PATCH",  "/pieces/" + id,     body);
export const deletePiece      = (id)         => req("DELETE", "/pieces/" + id);
export const getPieceSessions = (id)         => req("GET",    "/pieces/" + id + "/sessions");

// Practice Sessions
export const getSessionDates   = ()          => req("GET",    "/sessions/dates");
export const getSessionsForDay = (date)      => req("GET",    "/sessions?date=" + date);
export const createSession     = (body)      => req("POST",   "/sessions",         body);
export const updateSession     = (id, body)  => req("PATCH",  "/sessions/" + id, body);
export const deleteSession     = (id)        => req("DELETE", "/sessions/" + id);

// Coach
export const getCoachToday   = ()       => req("GET",    "/coach/today");
export const refreshCoach    = ()       => req("POST",   "/coach/refresh");
export const coachAction     = (status) => req("PATCH",  "/coach/action", { status });
export const getCoachPrefs   = ()       => req("GET",    "/coach/preferences");
export const saveCoachPrefs  = (body)   => req("POST",   "/coach/preferences", body);

// Coach AI Chat
export const coachChat = (message, messages) => req("POST", "/coach/chat", { message, messages });

// Admin
export const adminGetUsers   = ()       => req("GET",    "/admin/users");
export const adminCreateUser = (body)   => req("POST",   "/admin/users",      body);
export const adminUpdateUser = (id, b)  => req("PATCH",  "/admin/users/" + id, b);
export const adminDeleteUser = (id)     => req("DELETE", "/admin/users/" + id);
